//数据
export default {
	
	systemData:{},
	Login:{},
	Query:{},
	Search:{}
	
	
}